<template>
    <div class="MyPageHaeder">
        <ul class="breadcrumb">
            <li v-for="(cmenu, index) in menu" :key="index" @click="backLast(index, cmenu)">{{ cmenu.title }}</li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "pageHeader",
    data() {
        return {
            mene: [],
        }
    },
    props: {
        menu: {
            type: Array,
            required: true,
        },
    },
    methods: {
        backLast(index, title) {
            // this.$parent.dataList = this.menu.slice(0, index + 1);
            this.$emit('menu-change', this.menu.slice(0, index + 1))
        }
    },
    created() { },
    mounted() {
    },
}
</script>
<style lang="scss" scoped>
.MyPageHaeder {
    width: 100%;
    padding: 10px 22px;
    font-size: 26px;

    ul.breadcrumb {
        padding: 8px 16px;
        list-style: none;
        height: auto;
        overflow: hidden;
        overflow-x: auto;
        /* 设置x轴可滑动 */
        white-space: nowrap;
        /* 元素不换行 */
        width: auto;
        /* (宽度) */
    }

    /* 隐藏滚动条 */
    ul.breadcrumb::-webkit-scrollbar {
        display: none;
    }

    ul.breadcrumb li {
        display: inline;
        // color: gray;
    }

    ul.breadcrumb li+li:before {
        padding: 8px;
        color: black;
        content: "/\00a0";
    }

    ul.breadcrumb li {
        color: #1890F5;
    }

    ul.breadcrumb li:last-child {
        color: gray;
    }

    ul.breadcrumb li+li:before {
        padding: 8px;
        color: black;
        content: "/\00a0";
    }
}

// </style>
